import { useCallback, useMemo, useRef, useState } from "react";

type TIsOpenState = {
  close(): void;
  hasBeenOpened: boolean;
  isOpen: boolean;
  open(): void;
  setIsOpen(isOpen: boolean): void;
  toggle(): void;
};

export function useIsOpenState(defaultState = false): TIsOpenState {
  const [isOpen, setIsOpenState] = useState(defaultState);
  const hasBeenOpened = useRef(false);

  const open = useCallback(() => {
    if (!hasBeenOpened.current) {
      hasBeenOpened.current = true;
    }
    setIsOpenState(true);
  }, []);

  const close = useCallback(() => {
    setIsOpenState(false);
  }, []);

  const setIsOpen = useCallback((isOpen: boolean) => {
    setIsOpenState(isOpen);
  }, []);

  const toggle = useCallback(() => {
    setIsOpenState((current) => !current);
  }, []);

  // eslint-disable-next-line react-hooks/refs -- Legacy
  return useMemo(
    () => ({
      close,
      // eslint-disable-next-line react-hooks/refs -- Legacy
      hasBeenOpened: hasBeenOpened.current,
      isOpen,
      open,
      setIsOpen,
      toggle,
    }),
    [close, isOpen, open, setIsOpen, toggle],
  );
}
